import React from 'react';
import { type RestSpeechBubble2Modal } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import CustomerHtml from '@bbkFunnelComponents/customer_html/customer_html';
import ModalPerson from '@bbkFunnelComponents/modals/sections/person';
import SimpleModalTitle from './sections/simple-title';

type Props = Pick<RestSpeechBubble2Modal['requires'], 'info' | 'person'> & {
  actions: React.ReactNode;
};
const SpeechBubble2: React.FC<Props> = (props) => {
  const { info, person, actions } = props;

  return (
    <div className="speech-bubble-2">
      <SimpleModalTitle customStyles={{ paddingLeft: 30 }}>
        <CustomerHtml value={info.title} />
      </SimpleModalTitle>
      <div className="SBContainer">
        <div className="left">
          <ModalPerson person={person} />
        </div>
        <div className="right">
          <div className="quote">
            <div className="details">
              <CustomerHtml value={info.details} />
            </div>
            <div className="arrow-down" />
          </div>
          <div className="mobile-person">
            <ModalPerson person={person} horizontalSB />
          </div>
          <div className="action">{actions}</div>
        </div>
      </div>
    </div>
  );
};

export default SpeechBubble2;
